/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-12 15:38:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-19 14:31:36
 * @FilePath: /knit-web/src/router/constants.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const DEFAULT_LAYOUT = () => import('@/layout/default-layout.vue');

export const WHITE_LIST = [
  'Login',
  'Home',
  'notFound',
  'Contact',
  'Document',
  'Forbidden',
  'PrivacyPolicy',
  'TermsOfUse',
];
export const LOGIN_WITHOUT_WORKSPACE_LIST = ['BindInvite'];
export const NOT_FOUND = {
  name: 'notFound',
};
